export const AgentType = {
  GET_AGENT_DATA: "GET_AGENT_DATA",
  EDIT_AGENT_DATA: "EDIT_AGENT_DATA",
  EMPTY_AGENT_DATA: "EMPTY_AGENT_DATA",
  GET_ALL_AGENT: "GET_ALL_AGENT",
  ALL_EMAILS_THREADS: "ALL_EMAILS_THREADS",
  ALL_SMS_THREADS: "ALL_SMS_THREADS",
};
